import "../css/modal.css";
import { useState } from "react";
import { motion } from "framer-motion";
import { createPortal } from "react-dom";
import { ClosedCaption, ClosedCaptionIcon, XCircle } from "lucide-react";

function Modal({ title, content }) {
  const [open, setOpen] = useState(false);

  const handleOutsideClick = (e) => {
    if (e.target.classList.contains("modal-overlay")) {
      setOpen(false);
    }
  };

  return (
    <>
      <p className="modal-open" onClick={() => setOpen(true)}>
        <span className="link-with-arrow">{title}</span>
      </p>

      {open &&
        createPortal(
          <motion.div
            className="modal-overlay"
            onClick={handleOutsideClick}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            <motion.div
              className="modal-content-wrapper"
              initial={{ y: 80, scale: 0.95, opacity: 0 }}
              animate={{
                y: 0,
                scale: 1,
                opacity: 1,
                transition: { type: "spring", stiffness: 180 },
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <span
                className="modal-close-action"
                onClick={() => setOpen(false)}
              >
               <XCircle size={48}></XCircle>
              </span>

              {content}
            </motion.div>
          </motion.div>,
          document.body
        )}
    </>
  );
}

export default Modal;